import { render } from "./PageGreeting.vue?vue&type=template&id=c8f4fb86&scoped=true"
import script from "./PageGreeting.vue?vue&type=script&lang=js"
export * from "./PageGreeting.vue?vue&type=script&lang=js"

import "./PageGreeting.vue?vue&type=style&index=0&id=c8f4fb86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8f4fb86"]])

export default __exports__